import React from 'react'
import { styled } from 'styled-components'
import NewsSlider from './NewsSlider'
import RecentNews from './RecentNews'

const NewsSection = () => {

  return (
    <Container>
      {/*DEVELOPER MEMORY: Slider show of the latest news for AMRS */}
        <NewsSlider />
        <RecentNews />
    </Container>
  )
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export default NewsSection